import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  required?: boolean;
}

export const InputPatientAddress2: FC<Props> = ({ form, required }): JSX.Element => (
  <Form.Item label="Address Line 2">
    {form.getFieldDecorator('address2', {
      rules: [{ required: required, message: "Please enter patient's address." }],
    })(<Input allowClear />)}
  </Form.Item>
);
